module.exports = require('./helpers/bundle-url').getBundleURL('eIdJn') + "logo-dark.eefe0b7f.svg";